import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { queryClient } from '../../../App'
import { CheckboxStore } from '../../../stores/CheckboxStore'
import tableHeadCellStyles from '../../../utils/components/CustomTable/styles/tableHeadCellStyles'
import { getStyles } from '../../../utils/utils/commonUtils'
import { mapHeadTitles, sortedKeys } from '../consts/table.consts'
import { customersStore } from '../store/CustomersStore'
import { CustomerItem } from '../types/customer-filters.types'
import {
  customersPaginationStore,
  useCustomerTableData,
} from './useCustomerTableData'

export const customersCheckboxStore = new CheckboxStore()

export const useCustomerTable = () => {
  const navigate = useNavigate()
  // renderTable(false) имитирует isLoading состояние в случае когда данные беруться из кеша tanstackQuery.
  // Без renderTable(false) таблица при долгой отрисовке данных выглядит зависающей
  const [renderTable, setRenderTable] = useState(false)
  const { scrollHeight, sort, setSort, selectedRow } = customersPaginationStore

  const { data, isLoading, isFetching } = useCustomerTableData()

  const cellClasses = getStyles(tableHeadCellStyles, data)

  const isSmallLength = (data?.content?.length ?? 0) < 50

  useEffect(() => {
    window.scrollTo(0, 0)

    let timeoutId: NodeJS.Timeout
    if (!isLoading && !isFetching) {
      timeoutId = setTimeout(() => {
        setRenderTable(true)
      }, 0)
    }

    return () => {
      clearTimeout(timeoutId)
      queryClient.invalidateQueries({ queryKey: ['customers-table'] })
    }
  }, [])

  useEffect(() => {
    if (data?.content.length || (!isLoading && !isFetching)) {
      setRenderTable(true)
      data?.content.length &&
        customersCheckboxStore.setAllIds(data.content.map((el) => el.id))
      if (scrollHeight) {
        setTimeout(() => {
          window.scrollTo(0, scrollHeight)
        }, 0)
      }
    }
  }, [data?.content.length, renderTable, isLoading, isFetching])

  const getOnSort = (key: string) =>
    sortedKeys.includes(key)
      ? () => {
          setRenderTable(false)
          setSort(`-${key === 'name' ? 'fullname' : key.toLowerCase()}`)
        }
      : undefined

  const onRowClick = (el: CustomerItem) => {
    customersPaginationStore.setSelectedRow(el, window.scrollY)
    customersStore.setAllIds(data?.content.map((el) => el.id) ?? [])
    customersStore.setCurrId(el.id)
    navigate(`/customers/${el.id}`)
  }

  const columns = Object.keys(mapHeadTitles)

  return {
    cellClasses,
    isSmallLength,
    setRenderTable,
    isLoading: isLoading || isFetching || !renderTable,
    data,
    sort,
    getOnSort,
    selectedRow,
    columns,
    onRowClick,
  }
}
